export { HeroTakeoverSection } from './components/hero-takeover-section';
export {
  type HeroTakeoverFormalDegreeKey,
  type HeroTakeoverHeadline,
  type HeroTakeoverVariant,
  getHeroTakeoverCheckoutHref,
  HERO_TAKEOVER_CTA_LABEL,
  HERO_TAKEOVER_DEGREE_APPLICATION_CHECKOUT_PATH,
  HERO_TAKEOVER_STRIKETHROUGH_IMAGE,
  HERO_TAKEOVER_SUBSCRIBER_CHECKOUT_PATH,
} from './constants/hero-content';
